import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["placement", "arrowProps", "show", "popper", "hasDoneInitialMeasure"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import chunk from 'lodash/chunk';
import React, { useEffect, useRef, useState } from 'react';
import { Anchor, ANIMATION_TYPES, Card, Category, Overlay } from '@miro-site/ui-foundation';
import { getAnimationOffsetIndex } from '../helpers/get-animation-offset-index';
import { MenuItem } from './menu-item';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MAX_ITEMS_PER_COLUMN = 7;
export var FlyoutMenu = function FlyoutMenu(_ref) {
  var handleClose = _ref.handleClose,
      animated = _ref.animated,
      _children = _ref.children,
      href = _ref.href,
      label = _ref.label,
      setSelected = _ref.setSelected,
      show = _ref.show,
      _ref$withHoverBg = _ref.withHoverBg,
      withHoverBg = _ref$withHoverBg === void 0 ? true : _ref$withHoverBg;
  var target = useRef(null);

  var _useState = useState('bottom-start'),
      flyoutMenuPlacement = _useState[0],
      setFlyoutMenuPlacement = _useState[1];

  var hasSubmenu = !href && _children;
  var menuUniqueId = "main-nav-flyout-menu-".concat(label);
  var submenuUniqueId = "main-nav-flyout-submenu-".concat(label);
  /**
   * These refs are used to control the keyboard focus when the user
   * navigates the menu using the keyboard.
   */

  var menuButtonRef = useRef(null);
  var flyoutMenuRef = useRef(null);

  var handleSelect = function handleSelect() {
    if (href) {
      return;
    }

    setSelected(label);
  };

  var handleExit = function handleExit(focusMenuButton) {
    var _document$activeEleme;

    var menuButtonHasFocus = (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.className.includes('menu-item');

    if (menuButtonHasFocus || focusMenuButton === true) {
      requestAnimationFrame(function () {
        var _menuButtonRef$curren;

        /**
         * Return focus to the menu button when the flyout menu is closed.
         */
        menuButtonRef === null || menuButtonRef === void 0 ? void 0 : (_menuButtonRef$curren = menuButtonRef.current) === null || _menuButtonRef$curren === void 0 ? void 0 : _menuButtonRef$curren.focus();
      });
    }
  };

  useEffect(function () {
    var menuButtonHasFocus = document.activeElement === menuButtonRef.current;

    if (show && menuButtonHasFocus) {
      requestAnimationFrame(function () {
        var _flyoutMenuRef$curren;

        (_flyoutMenuRef$curren = flyoutMenuRef.current) === null || _flyoutMenuRef$curren === void 0 ? void 0 : _flyoutMenuRef$curren.focus();
      });
      return;
    }
  }, [show]);
  useEffect(function () {
    var isRTL = document.documentElement.getAttribute('dir') === 'rtl';

    if (isRTL) {
      setFlyoutMenuPlacement('bottom-end');
    }
  });
  return /*#__PURE__*/_jsxs("div", {
    ref: target,
    className: "d-flex align-self-center",
    onMouseLeave: handleClose,
    children: [/*#__PURE__*/_jsx(Anchor, _objectSpread(_objectSpread({
      as: "div",
      id: menuUniqueId,
      className: classNames('text-decoration-none', {
        hover: hasSubmenu && show
      }),
      ref: menuButtonRef,
      withHoverBg: withHoverBg,
      size: "sm",
      href: href,
      onMouseOver: handleSelect,
      onClick: handleSelect
    }, hasSubmenu && {
      iconEnd: 'ChevronDown',
      id: menuUniqueId,
      'aria-haspopup': true,
      'aria-controls': submenuUniqueId,
      'aria-expanded': show
    }), {}, {
      children: label
    })), /*#__PURE__*/_jsx(Overlay, {
      target: target.current,
      show: show,
      placement: flyoutMenuPlacement,
      onExit: function onExit() {
        return handleExit(false);
      },
      popperConfig: {
        modifiers: [{
          name: 'preventOverflow',
          options: {
            padding: 36
          }
        }]
      },
      children: function children(_ref2) {
        var _placement = _ref2.placement,
            _arrowProps = _ref2.arrowProps,
            _show = _ref2.show,
            _popper = _ref2.popper,
            _hasDoneInitialMeasure = _ref2.hasDoneInitialMeasure,
            props = _objectWithoutProperties(_ref2, _excluded);

        var animationDelay = 0;
        var columnCount = 0;
        var animationType = animated ? ANIMATION_TYPES.NONE : ANIMATION_TYPES.SLIDE_DOWN_FADE_IN;
        return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, props), {}, {
          style: _objectSpread({
            zIndex: 9999
          }, props.style),
          role: "menu",
          id: submenuUniqueId,
          "aria-labelledby": menuUniqueId,
          children: /*#__PURE__*/_jsx(Card, {
            className: "mt-500 border-0 shadow-100 mx-n300",
            children: /*#__PURE__*/_jsx(Card.Body, {
              className: classNames('px-300 py-400 d-inline-flex gap-300', {
                'animate-ease-in-bg': !animated
              }),
              children: _children === null || _children === void 0 ? void 0 : _children.map(function (node, groupIndex) {
                if (node !== null && node !== void 0 && node.children) {
                  var chunked = chunk(node.children, MAX_ITEMS_PER_COLUMN);
                  return /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsxs("div", {
                      className: "d-inline-flex flex-column gap-250",
                      children: [/*#__PURE__*/_jsx(Category, {
                        className: "mb-n50",
                        animationDelay: getAnimationOffsetIndex(columnCount, animationDelay++, MAX_ITEMS_PER_COLUMN),
                        animationType: animationType,
                        children: node.label
                      }), /*#__PURE__*/_jsx("div", {
                        className: "d-inline-flex gap-400",
                        children: chunked === null || chunked === void 0 ? void 0 : chunked.flatMap(function (chunk, columnIndex) {
                          var column = /*#__PURE__*/_jsx("ul", {
                            className: "list-unstyled d-inline-flex flex-column gap-250 w-100 p-0",
                            children: chunk.map(function (child, childIndex) {
                              /**
                               * The first item is assigned a reference to enable programmatic
                               * focus transfer from the menu button to the submenu when it
                               * opens, primarily used for keyboard navigation.
                               */
                              var isFirstItem = !groupIndex && !columnIndex && !childIndex;
                              return /*#__PURE__*/_jsx(MenuItem, {
                                ref: isFirstItem ? flyoutMenuRef : undefined,
                                tabIndex: 1,
                                href: child === null || child === void 0 ? void 0 : child.href,
                                label: child.label,
                                media: child === null || child === void 0 ? void 0 : child.media,
                                animationDelay: getAnimationOffsetIndex(columnCount, animationDelay++, MAX_ITEMS_PER_COLUMN),
                                animationType: animationType,
                                onBlur: function onBlur() {
                                  /**
                                   * Close the flyout menu when the user navigates
                                   * past the last item in the last column.
                                   */
                                  if (groupIndex === _children.length - 1 && columnIndex === chunked.length - 1 && childIndex === chunk.length - 1) {
                                    handleExit(true);
                                    setSelected('');
                                  }
                                }
                              }, child.label);
                            })
                          }, JSON.stringify(chunk));

                          if (chunked.length > 1) {
                            /**
                             * Offset the animation delay for the next column
                             * because there is no category for columns in the same
                             * category.
                             */
                            animationDelay++;
                          }
                          /**
                           * Increment the column count to calculate the animation
                           * delay for the next column.
                           */


                          columnCount++;
                          return column;
                        })
                      })]
                    })
                  }, node.label);
                }

                return /*#__PURE__*/_jsx(MenuItem, {
                  href: node === null || node === void 0 ? void 0 : node.href,
                  label: node.label,
                  media: node === null || node === void 0 ? void 0 : node.media,
                  animationDelay: animationDelay++,
                  animationType: animationType
                }, node.label);
              })
            })
          })
        }));
      }
    })]
  });
};